
import type { State } from '../types';
import type TimelineEventCollection from '../../models/TimelineEventCollection';
import type TimelineEvent from '../../models/TimelineEvent';

export function getTimelineEvents(state: State): TimelineEventCollection {
  return state.timeline.events;
}

export function getDefaultTimelineEvents(state: State): TimelineEventCollection {
  return state.timeline.defaultEvents;
}

export function isFetchingEvents(state: State): boolean {
  return state.timeline.isFetchingEvents;
}

export function isFetchingDefaultEvents(state: State): boolean {
  return state.timeline.isFetchingDefaultEvents;
}

export function isCreatingEvent(state: State): boolean {
  return state.timeline.isCreatingEvent;
}

export function isUpdatingEvent(state: State): boolean {
  return state.timeline.isUpdatingEvent;
}

export function isShowingEvent(state: State): boolean {
  return state.timeline.isShowingEvent;
}


export function getActiveEvent(state: State): ?TimelineEvent {
  return state.timeline.activeEvent;
}



// WEBPACK FOOTER //
// ./src/redux/timeline/selectors.js